export default function Heading(props) {
  const firstName = props.googleUser.split(" ")[0];
  return (
    <div className="flex justify-between m-8">
      <div className="flex">
        <h2 className="text-lg font-medium text-fifthDarkOrange m-auto">
          Welcome, {firstName}
        </h2>
      </div>
      <div className="">
        <span className="">
          <button
            onClick={props.logout}
            type="button"
            className="inline-flex items-center px-4 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-secondaryGreen hover:bg-primaryGreen focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primaryGreen"
          >
            Logout
          </button>
        </span>
      </div>
    </div>
  );
}
